import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Logo from '../../../../../../ECMv6/assets/logo/Saviynt-logo.svg';
import WhiteLogo from '../../../../../../ECMv6/assets/logo/Saviynt-logo-white.svg';
import './AppLogo.css';

const AppLogo = ({ src, isWhite, isSideNav, isGen2Nav }) => {
  const intl = useIntl();
  const [isLoaded, setIsLoaded] = useState(false);
  const style = isLoaded ? undefined : { visibility: 'hidden' };

  const altText = intl.formatMessage({
    id: 'gen2.appLogo.alt',
  });

  return (
    <div className="cl-logo">
      <img
        src={src || (!isWhite && isSideNav && WhiteLogo) || (!isGen2Nav && Logo)}
        style={style}
        className="cl-logo-icon"
        alt={altText}
        data-testid="logo"
        width="100px"
        onLoad={() => setIsLoaded(true)}
        aria-hidden={!isLoaded}
      />
    </div>
  );
};

AppLogo.propTypes = {
  src: PropTypes.string.isRequired,
};

export default AppLogo;
